/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1FundOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_MUTUALFUNDS_V1_FUND_ORDER_EVENT_ENTITY_NAME = 'ixc.mutualfunds.v1.FundOrderEvent';
export const ixcMutualfundsV1FundOrderEventEntity = new schema.Entity<IxcMutualfundsV1FundOrderEvent>(IXC_MUTUALFUNDS_V1_FUND_ORDER_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        requested: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcMutualfundsV1FundOrderEvent) => `${entity.metadata?.eventId}` });

